<template>
    <div>
        <div class="subtitle-2 pt-3 pb-1">{{typeText}}spiele</div>
        <v-data-table v-if="spiele.length > 0" :headers="headers" :items="spiele" class="elevation-2"
                      hide-default-footer mobile-breakpoint="1" disable-pagination>
            <template v-slot:item.gegen="{}">:</template>
            <template v-slot:item.punkte="{item}">
                <spieler-performance-sap-map :punkte="item.punkte"></spieler-performance-sap-map>
            </template>
            <template v-slot:item.quote="{item}">
                <schnitt-feld :value="item.quote"></schnitt-feld>
            </template>
            <template v-slot:item.spb="{item}">
                <v-btn icon @click="openSpielbericht(item)">
                    <v-icon>mdi-file-document-outline</v-icon>
                </v-btn>
            </template>
        </v-data-table>
        <v-card v-else><v-card-text>keine {{typeText}}spiele</v-card-text></v-card>
        <spiel-bericht-edit-confirm v-if="$route.query.action===action" :set-realtime="true"
                                    :currentData="selectedSpiel" :action="action">
        </spiel-bericht-edit-confirm>
    </div>
</template>

<script>
    import SchnittFeld from "./components/schnittFeld";
    import SpielerPerformanceSapMap from "./components/spielerPerformanceSapMap";
    import SpielBerichtEditConfirm from "./spielbericht/edit/spielBerichtEditConfirm";

    export default {
        components: {
            SpielBerichtEditConfirm,
            SpielerPerformanceSapMap,
            SchnittFeld},
        name: "spieler-performance-list",
        props: ['spiele', 'typeText'],
        computed: {
            action(){ return 'displayErgebnisSpieler' + this.typeText; }
        },
        data: () => ({
            headers: [
                { text: 'Runde', value: 'infos.runde', sortable: false},
                { text: 'Heim', value: 'infos.heimTeam', sortable: false, align: 'right'},
                { text: '', value: 'gegen', sortable: false, align: 'center'},
                { text: 'Gast', value: 'infos.gastTeam', sortable: false, align: 'left'},
                { text: 'Quote', value: 'quote', sortable: false, align: 'center'},
                { text: 'DG/Bahn', value: 'bahn', sortable: false, align: 'center'},
                { text: 'SaP/MaP', value: 'punkte', sortable: false, align: 'center'},
                { text: 'Gegner', value: 'gegner', sortable: false, align: 'left'},
                { text: 'SpB', value: 'spb', sortable: false, align: 'center'},
            ],
            selectedSpiel: null,
        }),
        methods: {
            async openSpielbericht(spiel){
                this.selectedSpiel = spiel;
                let p = JSON.parse(JSON.stringify(this.$route.path));
                let q = JSON.parse(JSON.stringify(this.$route.query));
                q.action = 'displayErgebnisSpieler' + this.typeText;
                this.$router.push({path: p, query: q});
            },
        },
    }
</script>

<style scoped>

</style>